module.exports = __webpack_public_path__ + "img/playground.50aeef86.svg";